import httpClient, { httpFormDataClient } from "./httpClient";

export interface Faq {
  id: number;
  question: string;
  answer: string;
  mediaFile?: {
    id: number;
    url?: string;
    extension?: string;
  };
  mediaLink?: string;
  imageUrl?: string;
  imageFileType?: string;
  createdAt: string;
  updateAt: string;
}

export interface CreateFaqDto {
  question: string;
  answer: string;
  mediaLink?: string;
}

export interface UpdateFaqDto {
  question?: string;
  answer?: string;
  mediaLink?: string;
}

export interface PaginationDto {
  limit?: number;
  offset?: number;
  param?: string;
}

export interface FaqsResponse {
  faqs: Faq[];
  total: number;
}

export const findAllFaqs = async (
  paginationDto?: PaginationDto
): Promise<FaqsResponse> => {
  const params: any = {};

  if (paginationDto?.limit) {
    params.limit = paginationDto.limit;
  }

  if (paginationDto?.offset !== undefined) {
    params.offset = paginationDto.offset;
  }

  if (paginationDto?.param) {
    params.param = paginationDto.param;
  }

  const response = await httpClient.get("/faqs", { params });
  return response.data;
};

export const findFaq = async (id: number): Promise<Faq> => {
  const response = await httpClient.get(`/faqs/${id}`);
  return response.data;
};

export const createFaq = async (
  data: CreateFaqDto,
  mediaFile?: File
): Promise<Faq> => {
  const formData = new FormData();
  formData.append("question", data.question);
  formData.append("answer", data.answer);

  if (data.mediaLink) {
    formData.append("mediaLink", data.mediaLink);
  }

  if (mediaFile) {
    formData.append("mediaFile", mediaFile);
  }

  const response = await httpFormDataClient.post("/faqs", formData);
  return response.data;
};

export const updateFaq = async (
  id: number,
  data: UpdateFaqDto,
  mediaFile?: File
): Promise<Faq> => {
  const formData = new FormData();

  if (data.question) {
    formData.append("question", data.question);
  }

  if (data.answer) {
    formData.append("answer", data.answer);
  }

  if (data.mediaLink) {
    formData.append("mediaLink", data.mediaLink);
  }

  if (mediaFile) {
    formData.append("mediaFile", mediaFile);
  }

  const response = await httpFormDataClient.patch(`/faqs/${id}`, formData);
  return response.data;
};

export const deleteFaq = async (id: number): Promise<void> => {
  await httpClient.delete(`/faqs/${id}`);
};
